module.exports = __webpack_public_path__ + "static/media/1.f88161aa.jpg";